var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoData = function SvgNoData(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 203,
    viewBox: "0 0 204 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1683 70.7197L-0.000214458 70.7197L11.1113 100.64L65.2798 100.64L54.1683 70.7197Z",
    fill: "url(#paint0_linear_227_42155)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_42155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.77 111.56C94.9035 95.4701 64.2341 55.3564 76.4918 23.6205C91.8139 -16.0493 159.137 12.1788 135.672 50.544C116.9 81.2362 59.8121 41.867 33.6146 18.3458",
    stroke: "#BBDEFB",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3716 100.326L193.659 100.326L193.659 188.238C193.659 195.378 187.871 201.166 180.731 201.166L24.2998 201.166C17.1597 201.166 11.3716 195.378 11.3716 188.238L11.3716 100.326Z",
    fill: "url(#paint1_linear_227_42155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.885 100.326L193.659 100.326L193.659 188.473C193.659 195.483 187.976 201.166 180.965 201.166L143.885 201.166L143.885 100.326Z",
    fill: "url(#paint2_linear_227_42155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.578 71.8867L203.998 71.8867L193.656 100.329L143.236 100.329L153.578 71.8867Z",
    fill: "url(#paint3_linear_227_42155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3721 100.326L143.24 100.326L136.462 127.437C135.886 129.739 133.818 131.354 131.445 131.354L10.2385 131.354C6.87421 131.354 4.40565 128.192 5.22161 124.928L11.3721 100.326Z",
    fill: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 150.995,
    y: 110.669,
    width: 36.1989,
    height: 10.3425,
    rx: 2.58564,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.9263,
    y: 15.7285,
    width: 4,
    height: 9,
    rx: 2,
    transform: "rotate(131.039 32.9263 15.7285)",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3518 20.9628C28.2964 21.8792 27.5086 22.5771 26.5922 22.5217V22.5217C25.6758 22.4663 24.9778 21.6785 25.0332 20.7621L25.2339 17.4435C25.2893 16.5271 26.0771 15.8291 26.9935 15.8845V15.8845C27.9099 15.9399 28.6079 16.7277 28.5525 17.6442L28.3518 20.9628Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.744 18.6893C21.8757 18.9877 20.93 18.5256 20.6317 17.6574C20.3334 16.7891 20.7955 15.8434 21.6637 15.5451L24.808 14.4648C25.6763 14.1665 26.622 14.6285 26.9203 15.4968C27.2186 16.3651 26.7565 17.3108 25.8883 17.6091L22.744 18.6893Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6189 13.7636C35.5189 13.5824 36.1016 12.7059 35.9204 11.8059C35.7392 10.9059 34.8627 10.3232 33.9627 10.5044L30.7034 11.1606C29.8034 11.3418 29.2207 12.2183 29.4019 13.1183C29.5831 14.0183 30.4596 14.601 31.3596 14.4198L34.6189 13.7636Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5938 8.5222C31.7696 7.62111 31.1816 6.74812 30.2805 6.57234C29.3794 6.39655 28.5064 6.98453 28.3307 7.88562L27.6941 11.1488C27.5183 12.0499 28.1063 12.9229 29.0074 13.0987C29.9085 13.2744 30.7815 12.6865 30.9572 11.7854L31.5938 8.5222Z",
    fill: "#BBDEFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_42155",
    x1: 23.1198,
    y1: 59.3864,
    x2: 37.1731,
    y2: 104.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDEFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_227_42155",
    x1: 101.869,
    y1: 113.901,
    x2: 103.463,
    y2: 201.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_227_42155",
    x1: 158.214,
    y1: 105.173,
    x2: 158.956,
    y2: 201.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDEFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_227_42155",
    x1: 164.56,
    y1: 64.3731,
    x2: 162.293,
    y2: 105.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBDEFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_42155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.972,
    height: 202.972,
    fill: "white",
    transform: "translate(1.02734)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-data.7cdd8f8b180d047ddba1c4cc8be568a8.svg";